/**
 * @author lihh
 * @description 表示首页
 */
// 导入axios
import request from '@/utils/request';

import {
  SERVICE_TYPE_HPM,
  SERVICE_TYPE_HPC
} from '@/utils/define';

/**
 * @author lihh
 * @description 获取名企
 * @param {*} data 
 */
export function HotComs(data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPM}/Home/HotComs?size=8`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 热门全职
 * @param {*} data 
 */
export function HotFullJobs(data = {}) {
    // 表示需要toekn
    data['tokenNeed'] = 1;
    return request({
        url: `/${SERVICE_TYPE_HPM}/Home/HotFullJobs?size=8`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 热门实习
 * @param {*} data 
 */
export function HotPartJobs(data = {}) {
    // 表示需要toekn
    data['tokenNeed'] = 1;
    return request({
        url: `/${SERVICE_TYPE_HPM}/Home/HotPartJobs?size=8`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 最新全职
 * @param {*} data 
 */
export function RecentFullJobs(data = {}) {
    // 表示需要toekn
    data['tokenNeed'] = 1;
    return request({
        url: `/${SERVICE_TYPE_HPM}/Home/RecentFullJobs?size=8`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 最新实习
 * @param {*} data 
 */
export function RecentPartJobs(data = {}) {
    // 表示需要toekn
    data['tokenNeed'] = 1;
    return request({
        url: `/${SERVICE_TYPE_HPM}/Home/RecentPartJobs?size=8`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 首页 选择次数
 * @param {*} data 
 */
export function getVisit(data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPC}/EnumData/getVisit`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 首页 轮播下面的图
 * @param {*} data 
 */
export function getByType1(data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPC}/ad/getByType?type=spc_wwgg&size=4`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 首页 轮播图
 * @param {*} data 
 */
export function getByType2(data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPC}/ad/getByType?type=spc_sylb`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 表示热门行业
 * @param {*} data 
 */
export function HotIndustries(data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPM}/Home/HotIndustries`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 获取热门搜索
 * @param {*} data 
 */
export function getHotSearch(data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPC}/RetrievalData/getHotSearch?type=2&size=6`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 专业类别
 * @param {*} data 
 */
export function PgetProfessional (data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPC}/RetrievalData/PgetProfessional`,
        method: 'POST',
        data
      });
}

/**
 * @author lihh
 * @description 职位类别
 * @param {*} data 
 */
export function PPositionTypes (data = {}) {

    return request({
        url: `/${SERVICE_TYPE_HPC}/RetrievalData/PPositionTypes`,
        method: 'POST',
        data
      });
}




// WEBPACK FOOTER //
// ./src/api/request/homePageService.js